import { render, staticRenderFns } from "./TemperatureSetting.vue?vue&type=template&id=fee84bea&scoped=true&"
import script from "./TemperatureSetting.vue?vue&type=script&lang=js&"
export * from "./TemperatureSetting.vue?vue&type=script&lang=js&"
import style0 from "./TemperatureSetting.vue?vue&type=style&index=0&id=fee84bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee84bea",
  null
  
)

export default component.exports